import util from '@bmp-vue/core/api/util'

const controller = 'correntistaPJSocio'
export default Object.assign(
  {},
  util.GetCrud(controller, ['getall', 'get', 'post', 'put', 'persist']),
  {
    ObterTodosPorCorrentista: function (dto) {
      return util.Axios.GetAll(controller, dto)
    },
    ObterPorCodigo: function (codigo) {
      return util.Axios.Get(controller, codigo)
    },
    InserirArquivo: function (request) {
      return util.Axios.Post(controller + '/Documentos', request)
    },
    ObterSocioSolicitacao: function (codigoPessoaDado) {
      return util.Axios.Get(controller + '/SocioSolicitacao', codigoPessoaDado)
    },
    InserirTermoSocios: function (request) {
      return util.Axios.Post(controller + '/TermoAceiteSocios', request)
    }
  }
)
